export * from './PageTypeFeature';
